// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    CheckboxesControl,
    InputControl,
    RadioButtonsControl,
    SelectControl,
    DatePickerControl,
} from "../../../molecules";
import {
    Box,
    FormControl,
    Stack,
    Typography,
    Autocomplete,
    TextField,
    useTheme,
    useMediaQuery,
    FormGroup,
    Switch,
    FormLabel,
    FormControlLabel,
    Divider,
    Tabs,
    Tab,
    Checkbox,
    Select,
    MenuItem,
    Card,
    CardContent,
    CardHeader,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Alert,
    AlertTitle
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Button, ComboboxWithFreeText, Loading, ComboboxState } from "../../../atoms";
import {
    useGetMerchantCategoryList,
    useMerchantAdd,
    useGetMerchantTypeList,
    useGetPosTypeList,
    useGetAllMerchantList,
    useGetCommissionProfileList,
    useGetCityList,
    useGetTaxAdministrationList,
    useGetMerchantStatusList,
    IMerchantAddRequest,
    IMerchant,
    useMerchantUpdate,
    useAuthorization,
    useGetAnnulmentCodeList,
    useGetIntegrationTypes,
    useGetMerchantUserPortfolioList,
    useGetAllSectorsQuery,
    useGetGibUserList,
    useGetDistrictList,
    useGetVPosIntegrationStatusList
} from "../../../../hooks";
import { useGetMerchantPassiveReasons } from "../../../../hooks/merchant/useGetMerchantPassiveReasons";
import { useEffect, useMemo, useState, useRef } from "react";
import { useUserMerchantId } from "../Merchant.state";
import { useSetSnackBar } from "../../../../store/Snackbar.state";
import {
    firstStepFormSchema,
    firstStepFormSchemaPassive,
    FirstStepFormValuesType,
    firstStepInitialValues,
} from "../_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { default as dayjs } from "dayjs";
import { useUserInfo } from "../../../../store/User.state";
import { MerchantAddFormAuthorizationSection, MerchantAddFormLimitSection, MerchantAddFormLimitSectionFormStates, MerchantAddFormTypeSection, MerchantAddFormTypeSectionFormStates } from '../components';
import { MerchantAddFormPartnerStep } from "../MerchantAddFormPartnerStep";
import { MerchantAddFormBankStep } from "../MerchantAddFormBankStep";
import { MerchantAddFormCurrencyStep } from "../MerchantAddFormCurrencyStep";
import { MerchantAuthorizationForm } from "../MerchantAuthorizationForm";
import { MerchantSpecialSettingsTab } from './tabs';
import { styled } from '@mui/material/styles';
import { MerchantAccount } from '../MerchantAccount';
import { MerchantBankAuthorizationPage } from "../../bank";

// { control, reset, handleSubmit, setValue, getValues, watch, errors }

const ScrollBox = styled(Box)(({ theme }) => ({
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

type MerchantAddFormCompanyStepProps = {
    onNext: () => void;
    merchant?: IMerchant;
    allData?: any;
    setAllData?: any;
};

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box >{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const MerchantSettingsV2 = ({
    merchant,
    allData,
    setAllData,
    merchantId
}: MerchantAddFormCompanyStepProps & { merchantId?: number }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const { showCreate } = useAuthorization();
    const { mutate: addMerchant, isLoading } = useMerchantAdd();
    const { mutate: updateMerchant, isLoading: updateLoading } =
        useMerchantUpdate();
    const [test, setMerchantId] = useUserMerchantId();
    const [taxAdministrations, setTaxAdministrations] = useState([]);
    const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
        useGetMerchantStatusList({});
    const { data: rawMerchantTypes, isLoading: isMerchantTypeLoading } =
        useGetMerchantTypeList({});
    const { data: rawIntegraionTypes, isLoading: isIntegrationTypesLoading } =
        useGetIntegrationTypes({
            page: 0,
            size: 25,
            orderByDesc: true,
            orderBy: 'CreateDate'
        });

    const { data: rawPosTypes, isLoading: isPosTypeLoading } = useGetPosTypeList(
        {}
    );
    const [userInfo] = useUserInfo();
    const { data: rawMerchantList, isLoading: isMerchantListLoading } =
        useGetAllMerchantList("ACTIVE");
    const {
        data: rawMerchantCategoryList,
        isLoading: isMerchantCategoryLoading,
    } = useGetMerchantCategoryList({});
    const {
        data: rawCommissionProfileList,
        isLoading: isCommissionProfileListLoading,
    } = useGetCommissionProfileList({});
    const { data: rawCityList, isLoading: isCityListLoading } = useGetCityList(
        {}
    );
    const {
        data: rawSectorList,
        isLoading: isSectorLoading,
    } = useGetAllSectorsQuery({
        page: 1,
        size: 9999
    });

    const [isPassiveSelected, setIsPassiveSelected] = useState(false);

    const { control, reset, handleSubmit, setValue, getValues, watch, errors } =
        useForm<FirstStepFormValuesType>({
            resolver: zodResolver(isPassiveSelected ? firstStepFormSchemaPassive : firstStepFormSchema),
            defaultValues: firstStepInitialValues,
            mode: 'onChange'
        });

    const { data: rawUserPortfolioList } = useGetMerchantUserPortfolioList();

    const { mutate: getTaxAdministrationList, isLoading: isTaxListLoading } =
        useGetTaxAdministrationList();
    const { data: rawAnnulmentCode, isLoading: isAnnulmentCodeLoading } = useGetAnnulmentCodeList({});
    const { data: rawVPosIntegrationStatus, isLoading: isVPosIntegrationStatusLoading } = useGetVPosIntegrationStatusList({});
    const { data: rawMerchantPassiveReasons, isLoading: isMerchantPassiveReasonsLoading } = useGetMerchantPassiveReasons();
    const [gbAliasList, setGbAliasList] = useState([] as any);
    const { mutate: rawGbAliasList, isLoading: isGetGbAliasLoading } = useGetGibUserList(); // Your API hook
    const taxNumberWatch = watch('taxNumber');
    const isPayoutBlockedWatch = watch('isPayoutBlocked');
    const isCallbackUrlControlWatch = watch('isCallbackUrlControl');
    const [isTaxAndInvoiceGbAliasValid, setIsTaxAndInvoiceGbAliasValid] = useState(true);
    const [isTaxAndEArchiveGbAliasValid, setIsTaxAndEArchiveGbAliasValid] = useState(true);
    const integratorGbAlias = watch('integratorGbAlias');
    const integratorEArchiveGbAlias = watch('integratorEArchiveGbAlias');
    const [tabValue, setTabValue] = useState(0);

    const { mutate: getDistrictList, isLoading: isDistrictListLoading } = useGetDistrictList();
    const [districts, setDistricts] = useState([]);
    const cityIdForDistricts = watch('cityId');

    useEffect(() => {
        if (cityIdForDistricts) {
            getDistrictList({ cityCode: cityIdForDistricts.toString() }, {
                onSuccess(data) {
                    const tempData = data?.data?.map(
                        (item: { name: string; id: number }) => {
                            return {
                                label: item.name,
                                value: item.id,
                            };
                        }
                    );
                    setDistricts(tempData);
                },
            });
        }
    }, [cityIdForDistricts, getDistrictList]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };


    useEffect(() => {
        if (taxNumberWatch?.length === 10) {
            rawGbAliasList({
                taxNumber: taxNumberWatch
            }, {
                onSuccess(data) {
                    const tempData = data?.data?.map(
                        (item: string) => {
                            return {
                                label: item,
                                value: `${item}`,
                            };
                        }
                    );
                    setGbAliasList(tempData);
                },
                onError(error) {
                    setGbAliasList([]);
                }
            });
        } else {
            setGbAliasList([]);
        }
    }, [taxNumberWatch]);

    useEffect(() => {
        if (integratorGbAlias && gbAliasList?.length > 0) {
            const isValid = gbAliasList.some(item => item.value === integratorGbAlias);
            setIsTaxAndInvoiceGbAliasValid(isValid);
        }
    }, [integratorGbAlias, gbAliasList]);

    useEffect(() => {
        if (integratorEArchiveGbAlias && gbAliasList?.length > 0) {
            const isValid = gbAliasList.some(item => item.value === integratorEArchiveGbAlias);
            setIsTaxAndEArchiveGbAliasValid(isValid);
        }
    }, [integratorEArchiveGbAlias, gbAliasList]);

    const selectedMerchantStatus = watch("merchantStatusType");

    useEffect(() => {
        setIsPassiveSelected(selectedMerchantStatus === "PASSIVE");
        if (selectedMerchantStatus !== "BLOCKED") {
            setValue("merchantStatusDescription", "");
        }
    }, [selectedMerchantStatus, setValue]);

    const [selectedCity, setSelectedCity] = useState(null as any);
    const [selectedMcc, setSelectedMcc] = useState(null as any);
    const [selectedIntegrationType, setSelectedIntegrationType] = useState(null as any);
    const [selectedMerchant, setSelectedMerchant] = useState(0);
    const [isPaymentDescriptionActiveState, setIsPaymentDescriptionActiveState] = useState(false);
    const [isUnlimitedLink, setIsUnlimitedLink] = useState(false);
    const [isIntegrationStatusActive, setIsIntegrationStatusActive] = useState(false);
    const [selectedUserPortfolio, setSelectedUserPortfolio] = useState(null as any);
    const [selectedVPosIntegrationStatus, setSelectedVPosIntegrationStatus] = useState(null as any);
    const [selectedCompanyType, setSelectedCompanyType] = useState(null as any);
    const [integratorMerchantId, setIntegratorMerchantId] = useState(null as any);
    const setSnackbar = useSetSnackBar();

    useEffect(() => {
        selectedCity &&
            getTaxAdministrationList(
                { cityCode: `${selectedCity.value}` },
                {
                    onSuccess(data) {
                        const tempData = data?.data?.map(
                            (item: { name: string; taxAdministrationCode: string }) => {
                                return {
                                    label: item.name,
                                    value: `${item.taxAdministrationCode}`,
                                };
                            }
                        );
                        setTaxAdministrations(tempData);
                    },
                }
            );
    }, [getTaxAdministrationList, selectedCity]);

    const merchantTypes = useMemo(() => {
        return rawMerchantTypes?.data?.map(
            (merchantType: { value: string; key: number }) => {
                return {
                    label: merchantType.value,
                    value: `${merchantType.key}`,
                };
            }
        );
    }, [rawMerchantTypes?.data]);

    const integrationTypes = useMemo(() => {
        return rawIntegraionTypes?.data?.map(
            (iType: { value: string; id: number }) => {
                return {
                    label: iType.value,
                    value: `${iType.id}`,
                };
            }
        );
    }, [rawIntegraionTypes?.data]);

    const sectors = useMemo(() => {
        return rawSectorList?.data?.result?.map(
            (iType: { sectorName: string; id: number }) => {
                return {
                    label: iType.sectorName,
                    value: `${iType.id}`,
                };
            }
        );
    }, [rawSectorList?.data]);

    const merchantStatuses = useMemo(() => {
        return rawMerchantStatus?.data?.map(
            (merchantStat: { value: string; key: number }) => {
                return {
                    label: merchantStat.key,
                    value: `${merchantStat.value}`,
                };
            }
        );
    }, [rawMerchantStatus?.data]);

    const posTypes = useMemo(() => {
        return rawPosTypes?.data?.map(
            (rawPosType: { key: string; value: string }) => {
                return {
                    label: rawPosType.value,
                    value: rawPosType.key,
                };
            }
        );
    }, [rawPosTypes?.data]);



    const annulmentCodes = useMemo(() => {
        return rawAnnulmentCode?.data?.map(
            (annulment: { description: string; code: string }) => {
                return {
                    label: annulment.description,
                    value: annulment.code,
                };
            }
        );
    }, [rawAnnulmentCode?.data]);

    const vPosIntegrationStatusList = useMemo(() => {
        return rawVPosIntegrationStatus?.data?.map(
            (status: { value: string; key: number }) => {
                return {
                    label: status.value,
                    value: `${status.key}`,
                };
            }
        );
    }, [rawVPosIntegrationStatus?.data]);


    const merchantAllList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data]);

    const merchantList = useMemo(() => {
        if (userInfo.merchantId == 0) {
            return rawMerchantList?.data?.map(
                (rawPosType: { merchantName: string; merchantId: number }) => {
                    return {
                        label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
                        value: rawPosType.merchantId,
                    };
                }
            );
        } else {
            return rawMerchantList?.data
                ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
                    return rawPosType.merchantId === Number(userInfo.merchantId);
                })
                .map((filteredMerchant) => {
                    return {
                        label: filteredMerchant.merchantName + ` (${filteredMerchant.merchantId})`,
                        value: filteredMerchant.merchantId,
                    };
                });
        }
    }, [rawMerchantList?.data, userInfo.merchantId, isMerchantListLoading]);

    const [formState, setFormState] = useState<MerchantAddFormAuthorizationSectionFormStates>({
        isUnlimitedLinkActive: false,
        isLinkCreationActive: false,
        isNonSecureActive: false,
        linkPaymentExpireInHour: 0,
        linkQuantity: 1
    });

    const [formStateLimit, setFormStateLimit] = useState<MerchantAddFormLimitSectionFormStates>({
        hasGiroRestriction: false,
        hasAutomaticGiroLimitIncrease: false,
        commercialFlag: false,
        giroLimit: 0,
        corporateFlag: false
    });

    const commissionProfileList = useMemo(() => {
        return rawCommissionProfileList?.data?.result?.map(
            (rawPosType: { name: string; code: string }) => {
                return {
                    label: rawPosType.name,
                    value: `${rawPosType.code}`,
                };
            }
        );
    }, [rawCommissionProfileList?.data?.result]);

    const cityList = useMemo(() => {
        return rawCityList?.data?.map(
            (city: { name: string; cityCode: string; cityOId: number }) => {
                return {
                    label: city.name,
                    value: city.cityCode,
                    id: city.cityOId,
                };
            }
        );
    }, [rawCityList?.data]);

    const userPortfolioList = useMemo(() => {
        return rawUserPortfolioList?.data?.map((user: { id: number; fullName: string; mail: string }) => {
            return { label: user.fullName + ` (${user.mail})`, value: `${user.id}` };
        });
    }, [rawUserPortfolioList?.data]);

    const merchantCategoryList = useMemo(() => {
        return rawMerchantCategoryList?.data?.map(
            (rawMerchantCategory: { description: string; code: string }) => {
                return {
                    label: `${rawMerchantCategory.code} - ${rawMerchantCategory.description}`,
                    value: `${rawMerchantCategory.code}`,
                };
            }
        );
    }, [rawMerchantCategoryList?.data]);

    const originalMccList = useMemo(() => {
        const list = rawMerchantCategoryList?.data?.map(
            (rawMerchantCategory: { description: string; code: string }) => {
                return {
                    label: `${rawMerchantCategory.code} - ${rawMerchantCategory.description}`,
                    value: rawMerchantCategory.code,
                };
            }
        );
        return list;
    }, [rawMerchantCategoryList?.data]);

    const merchantPassiveReasons = useMemo(() => {
        return rawMerchantPassiveReasons?.data?.map(
            (reason: { description: string }) => {
                return {
                    label: reason.description,
                    value: reason.description,
                };
            }
        );
    }, [rawMerchantPassiveReasons?.data]);

    const onSubmit = ({
        merchantStatusType,
        parentMerchantId,
        posList,
        taxOfficeCode,
        tradeRegistrationNumber,
        tradeName,
        aggreementDate,
        openingDate,
        mcc,
        foundationDate,
        citizenshipNumber,
        taxNumber,
        merchantType,
        merchantName,
        commissionProfileCode,
        webSite,
        closedDate,
        annulmentCode,
        hostingCompanyName,
        hostingCompanyCitizenNumber,
        status,
        annulmentStaff,
        annulmentCodeDesc,
        passiveReason,
        paymentDescriptionPlaceholder,
        linkPaymentHour,
        linkQuantity,
        giroLimit,
        integrationTypeId,
        sectorId,
        isInvoiceSendAsEmailEnabled,
        invoiceEmail,
        integratorId,
        integratorGbAlias,
        integratorEArchiveGbAlias,
        integratorUid,
        integratorPwd,
        erpCustomerCode,
        walletNo,
        eftDescription,
        paymentBlockedDay,
        blockedDay,
        isPayoutBlocked,
        payoutBlockReason,
        originalMcc = "",
        addressLine1, addressLine2, cityId, districtId, mobilePhoneNumber, zipCode, emailAddress1, emailAddress2, faxNumber, addressPhoneNumber, vPosIntegrationStatus,
        merchantStatusDescription,
        isCallbackUrlControl,
        callbackUrl,
        editorDescription,
        employeeCount,
        estimatedGiro
    }: FirstStepFormValuesType) => {
        const payoutBlockReasonValue =
            payoutBlockReason && typeof payoutBlockReason === 'object'
                ? (payoutBlockReason as any).value
                : payoutBlockReason;
        const taxOffice = taxAdministrations?.find(
            (item: { value: string }) => item?.value === taxOfficeCode
        ) as unknown as { value: string; label: string };
        const selectedAnnulment = annulmentCodes.find(
            (option) => option.value === annulmentCode
        );
        const derivedAnnulmentCodeDesc = selectedAnnulment ? selectedAnnulment.label : "";

        const formValues = getValues();

        const finalOriginalMcc = originalMcc || formValues.originalMcc || "";
        const formattedEditorDescription = editorDescription ? editorDescription.split('\n').join('|') : '';

        const request: IMerchantAddRequest = {
            memberId: 1,
            merchantType: +merchantType,
            merchantStatusType,
            status: merchantStatusType,
            mobilePos: false,
            cepPos: false,
            vpos: false,
            pos: false,
            parentMerchantId: selectedMerchant?.value
                ? Number(selectedMerchant?.value)
                : 0,
            merchantName,
            tradeName,
            tradeRegistrationNumber,
            commissionProfileCode,
            webSite,
            taxNumber,
            taxOfficeCode,
            taxOfficeName: taxOffice.label,
            citizenshipNumber,
            passiveReason,
            annulmentStaff: annulmentStaff ? annulmentStaff : "",
            annulmentCodeDesc: derivedAnnulmentCodeDesc,
            hostingCompanyName: hostingCompanyName ? hostingCompanyName : "",
            hostingCompanyCitizenNumber: hostingCompanyCitizenNumber ? hostingCompanyCitizenNumber : "",
            mcc: mcc,
            openingDate: openingDate ? dayjs(openingDate).format("YYYY-MM-DD") : null,
            aggreementDate: aggreementDate
                ? dayjs(aggreementDate).format("YYYY-MM-DD")
                : null,
            closedDate: closedDate ? dayjs(closedDate).format("YYYY-MM-DD") : null,
            annulmentCode: annulmentCode ? annulmentCode : "",
            phoneNumber: addressPhoneNumber,
            addressPhoneNumber,
            addressLine1,
            addressLine2,
            cityId: Number(cityId) || 0,
            districtId: Number(districtId) || 0,
            mobilePhoneNumber,
            zipCode,
            emailAddress1,
            emailAddress2,
            faxNumber,
            description: "",
            isPaymentDescriptionActive: isPaymentDescriptionActiveState,
            ...posList,
            paymentDescriptionPlaceholder,
            integrationTypeId: integrationTypeId,
            userPortfolioId: selectedUserPortfolio,
            isUnlimitedLink: formState.isUnlimitedLink ? formState.isUnlimitedLink : false,
            linkPaymentActive: formState.isLinkCreationActive ? formState.isLinkCreationActive : false,
            linkPaymentHour: linkPaymentHour ? Number(linkPaymentHour) : 0,
            linkQuantity: linkQuantity ? Number(linkQuantity) : 0,
            restrictedLink: formState.isRestrictedLink ? formState.isRestrictedLink : false,
            nonSecure: formState.isNonSecureActive ? formState.isNonSecureActive : false,
            hasGiroRestriction: formStateLimit.hasGiroRestriction ? formStateLimit.hasGiroRestriction : false,
            hasAutomaticGiroLimitIncrease: formStateLimit.hasAutomaticGiroLimitIncrease ? formStateLimit.hasAutomaticGiroLimitIncrease : false,
            giroLimit: giroLimit,
            corporateFlag: selectedWorkplaceType?.value == 1,
            commercialFlag: selectedWorkplaceType?.value == 2,
            isOnlyTabUpdate: false,
            sectorId: Number(sectorId) ?? 0,
            isInvoiceSendAsEmailEnabled,
            invoiceEmail: invoiceEmail,
            integratorMerchantId: integratorMerchantId,
            integratorId: integratorId ? Number(integratorId) : 0,
            integratorUid: integratorUid || '',
            integratorPwd: integratorPwd || '',
            integratorGbAlias: integratorGbAlias || '',
            integratorEArchiveGbAlias: integratorEArchiveGbAlias || '',
            erpCustomerCode: erpCustomerCode || 0,
            walletNo: walletNo || '',
            eftDescription: eftDescription || '',
            paymentBlockedDay: Number(paymentBlockedDay) || null,
            blockedDay: Number(blockedDay) || null,
            isPayoutBlocked,
            payoutBlockReason: payoutBlockReasonValue || '',
            originalMcc: finalOriginalMcc,
            vPosIntegrationStatus: Number(vPosIntegrationStatus),
            merchantStatusDescription,
            editorDescription: formattedEditorDescription,
            isCallbackUrlControl,
            callbackUrl,
            employeeCount: employeeCount ? Number(employeeCount) : 0,
            estimatedGiro: estimatedGiro ? Number(estimatedGiro) : 0,
        };
        if ((allData && allData?.id > 0) || (allData && allData?.merchantType)) {
            updateMerchant(
                {
                    ...request,
                    id: allData?.id || 0,
                    hashPassword: allData?.hashPassword || allData?.hashPassword || "",
                    merchantId: allData?.merchantId || allData?.merchantId || 0,

                },
                {
                    onSuccess(data) {
                        if (data.isSuccess && selectedMerchantStatus !== "PASSIVE") {
                            const merchantId = data.data.merchant[0].merchantId;
                            setMerchantId(merchantId);
                            setAllData({ ...allData, ...request, merchantId: merchantId, city: selectedCity?.value, taxOfficeCityCode: selectedCity?.value, cityCode: Number(cityId) || 0 });
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: data.message,
                            });
                        } else if (data.isSuccess && selectedMerchantStatus === "PASSIVE") {
                            setSnackbar({
                                severity: "success",
                                isOpen: true,
                                description: (
                                    <>
                                        {data.message}
                                    </>
                                ),
                            });
                        } else {
                            setSnackbar({
                                severity: "error",
                                isOpen: true,
                                description: data.message,
                            });
                        }
                    },
                    onError: (error) => {
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: "İşlem sırasında bir hata oluştu",
                        });
                    },
                });
        } else {
            addMerchant(request, {
                onSuccess(data) {
                    if (data.isSuccess && selectedMerchantStatus !== "PASSIVE") {
                        const merchantId = data.data.merchantId;
                        const id = data.data.id;
                        setMerchantId(merchantId);
                        setAllData({ ...allData, ...request, merchantId: merchantId, id, city: selectedCity?.value, taxOfficeCityCode: selectedCity?.value, cityCode: Number(cityId) || 0 });
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message,
                        });
                    } else if (data.isSuccess && selectedMerchantStatus === "PASSIVE") {
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: (
                                <>
                                    {data.message}
                                    <br />
                                    Pasif Üye İşyeri Bir sonraki Adıma Geçemez
                                </>
                            ),
                        });
                    } else if (data.isSuccess && selectedMerchantStatus === "BLACKLISTED") {
                        setSnackbar({
                            severity: "warning",
                            isOpen: true,
                            description: (
                                <>
                                    {data.message}
                                </>
                            ),
                        });
                    } else {
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: data.message,
                        });
                    }
                },
                onError: (error) => {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: "İşlem sırasında bir hata oluştu",
                    });
                },
            });
        }
    };

    const city = watch("city");
    const mcc = watch("mcc");
    const originalMcc = watch("originalMcc");

    // Düzenleme modunda olup olmadığımızı tüm alanlara bakarak kontrol ediyoruz (allData'da mcc veya originalMcc varsa düzenleme modu)
    const isEditMode = allData && (allData.mcc || allData.originalMcc);

    // Önceki değerleri takip etmek için useRef kullandım burada
    const prevMccRef = useRef(mcc);
    const prevOriginalMccRef = useRef(originalMcc);
    const isUpdatingRef = useRef(false);

    useEffect(() => {
        if (!isEditMode && !isUpdatingRef.current) {
            const prevMcc = prevMccRef.current;
            const prevOriginalMcc = prevOriginalMccRef.current;

            //Düzenleme modundayken MCC ve originalMcc'nin birbirini etkilemesini engelliyorum burada
            if (mcc !== prevMcc && originalMcc === prevOriginalMcc) {
                isUpdatingRef.current = true;
                if (mcc) {
                    setValue("originalMcc", mcc);
                } else {
                    setValue("originalMcc", "");
                }
                setTimeout(() => {
                    isUpdatingRef.current = false;
                }, 0);
            }

            // OriginalMcc değişti ve mcc değişmedi  
            if (originalMcc !== prevOriginalMcc && mcc === prevMcc) {
                isUpdatingRef.current = true;
                if (originalMcc) {
                    setValue("mcc", originalMcc);
                } else {
                    setValue("mcc", "");
                }
                setTimeout(() => {
                    isUpdatingRef.current = false;
                }, 0);
            }
        }
        // mcc ve originalMcc'nin önceki değerlerini güncelliyorum ayrı ayrı olacak şekilde
        prevMccRef.current = mcc;
        prevOriginalMccRef.current = originalMcc;
    }, [mcc, originalMcc, setValue, isEditMode]);

    useEffect(() => {
        if (!!allData && JSON.stringify(allData) !== "{}") {
            if (selectedCity === null || selectedCity === undefined) {
                setSelectedCity(
                    cityList?.find(
                        (c: any) =>
                            c.value === allData?.taxOfficeCityCode
                    )
                );
            }
            setIsPaymentDescriptionActiveState(allData.isPaymentDescriptionActive);
            setIsUnlimitedLink(allData.isUnlimitedLink);
            setIsIntegrationStatusActive(allData.integrationStatus);
            setSelectedIntegrationType(allData.integrationTypeId);
            setSelectedUserPortfolio(allData.userPortfolioId);
            setSelectedCompanyType(allData.merchantType);
            setSelectedWorkplaceType(workplaceTypes.find((w) => w.value == allData.corporateFlag ? 1 : 2));

            const isInvoiceEnabled = allData.isInvoiceSendAsEmailEnabled || false;
            setValue('isInvoiceSendAsEmailEnabled', isInvoiceEnabled);
            setValue('invoiceEmail', allData.invoiceEmail || '');

            const selectedStatus = vPosIntegrationStatusList?.find(s => s.value == allData.VPosIntegrationStatus);
            setSelectedVPosIntegrationStatus(selectedStatus);

            reset({
                merchantType: `${allData.merchantType}`,
                parentMerchantId: allData.parentMerchantId,
                merchantStatusType: allData.merchantStatusType,
                merchantName: allData.merchantName,
                tradeName: allData.tradeName,
                tradeRegistrationNumber: allData.tradeRegistrationNumber,
                commissionProfileCode: allData.commissionProfileCode,
                webSite: allData.webSite,
                city: selectedCity,
                taxNumber: allData.taxNumber,
                taxOfficeCode: allData.taxOfficeCode,
                citizenshipNumber: allData.citizenshipNumber,
                hostingCompanyName: allData.hostingCompanyName,
                hostingCompanyCitizenNumber: allData.hostingCompanyCitizenNumber,
                mcc: allData.mcc,
                originalMcc: allData.originalMcc || "",
                openingDate: dayjs(allData.openingDate),
                aggreementDate: dayjs(allData.aggreementDate),
                closedDate: allData.closedDate ? dayjs(allData.closedDate) : null,
                annulmentCode: allData.annulmentCode,
                annulmentStaff: allData.annulmentStaff,
                annulmentCodeDesc: allData.annulmentCodeDesc,
                passiveReason: allData.passiveReason ? `${allData.passiveReason}` : "",
                isPaymentDescriptionActive: allData.isPaymentDescriptionActive,
                postList: allData.pos,
                paymentDescriptionPlaceholder: allData.paymentDescriptionPlaceholder,
                posList: {
                    vpos: allData?.vpos,
                    pos: allData?.pos,
                    mobilePos: allData?.mobilePos,
                    cepPos: allData?.cepPos,
                },
                integrationTypeId: `${allData.integrationTypeId}`,
                userPortfolioId: `${allData.userPortfolioId}`,
                linkPaymentHour: allData.linkPaymentHour,
                linkQuantity: allData.linkQuantity,
                nonSecure: allData.nonSecure,
                sectorId: allData.sectorId,
                isInvoiceSendAsEmailEnabled: isInvoiceEnabled,
                invoiceEmail: allData.invoiceEmail || '',
                integratorMerchantId: allData.integratorMerchantId,
                integratorId: allData.integratorId || 30,
                integratorUid: allData.integratorUid || '',
                integratorPwd: allData.integratorPwd || '',
                integratorGbAlias: allData.integratorGbAlias || '',
                integratorEArchiveGbAlias: allData.integratorEArchiveGbAlias || '',
                erpCustomerCode: allData.erpCustomerCode || '',
                walletNo: allData.walletNo || '',
                eftDescription: allData.eftDescription || '',
                linkExpireInMinutes: allData.linkExpireInMinutes || 0,
                paymentBlockedDay: allData.paymentBlockedDay || null,
                blockedDay: allData.blockedDay || null,
                addressLine1: allData.addressLine1,
                addressLine2: allData.addressLine2,
                cityId: allData.cityCode,
                cityCode: allData.cityCode,
                districtId: allData.districtId,
                mobilePhoneNumber: allData.mobilePhoneNumber,
                zipCode: allData.zipCode,
                emailAddress1: allData.emailAddress1,
                emailAddress2: allData.emailAddress2,
                faxNumber: allData.faxNumber,
                addressPhoneNumber: allData.addressPhoneNumber || allData.phoneNumber,
                isPayoutBlocked: allData.isPayoutBlocked || false,
                payoutBlockReason: allData.payoutBlockReason || '',
                vPosIntegrationStatus: `${allData.vPosIntegrationStatus}` || '',
                merchantStatusDescription: allData.merchantStatusDescription,
                editorDescription: allData.editorDescription ? allData.editorDescription.split('|').join('\n') : '',
                isCallbackUrlControl: allData.isCallbackUrlControl || false,
                callbackUrl: allData.callbackUrl || '',
                employeeCount: allData.employeeCount || 0,
                estimatedGiro: allData.estimatedGiro || 0,
            });
        }
    }, [
        cityList,
        allData,
        merchantCategoryList,
        posTypes,
        reset,
        // selectedCity,
        selectedMcc,
        setValue,
    ]);

    useEffect(() => {
        if (!!allData && JSON.stringify(allData) !== "{}") {
            if (selectedCity === null || selectedCity === undefined) {
                setSelectedCity(
                    cityList?.find(
                        (c: any) =>
                            c.value === allData?.taxOfficeCityCode
                    )
                );
            }

            reset((prevValues) => ({
                ...prevValues,
                city: selectedCity,
                taxOfficeCode: allData.taxOfficeCode,
            }));

        }
    }, [selectedCity]);

    useEffect(() => {
        if (allData && allData.taxOfficeCode) {
            const cityCode = allData.taxOfficeCityCode;
            const cityRelatedToTaxOfficeCode = cityList?.find(
                (city) => city.value === cityCode
            );

            setSelectedCity(cityRelatedToTaxOfficeCode);
        }
    }, [allData, cityList]);

    useEffect(() => {
        if (allData?.parentMerchantId && merchantList?.length > 0) {
            const selected = merchantList.find(
                (merc: any) => merc?.value == allData?.parentMerchantId
            );
            if (selected != null) setSelectedMerchant(selected);
        }

    }, [merchantList, allData])

    useEffect(() => {
        if (selectedMerchantStatus === "ACTIVE" || selectedMerchantStatus === "BLOCKED") {
            setValue("annulmentCode", ""); // annulmentCode değerini sıfırla
            setValue("annulmentStaff", "")
            setValue("annulmentCodeDesc", "")
            setValue("closedDate", null);  // closedDate değerini sıfırla
        }
    }, [selectedMerchantStatus, setValue]);

    const workplaceTypes = [
        {
            label: 'Ticari',
            value: 1
        },
        {
            label: 'Kurumsal',
            value: 2
        }
    ];
    const [selectedWorkplaceType, setSelectedWorkplaceType] = useState(null as any);

    const hasLoading =
        isMerchantCategoryLoading ||
        isLoading ||
        isMerchantListLoading ||
        isMerchantStatusLoading ||
        updateLoading ||
        isMerchantStatusLoading ||
        isMerchantTypeLoading ||
        isPosTypeLoading ||
        isCommissionProfileListLoading ||
        isCityListLoading ||
        isTaxListLoading ||
        isIntegrationTypesLoading ||
        isSectorLoading ||
        isMerchantPassiveReasonsLoading;

    const posListWatch = watch('posList');

    const sectionRefs = useRef<{ [key: string]: HTMLElement | null }>({});
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);
    const sections = useMemo(() => [
        { id: 'company-info', title: 'Şirket ve İşyeri Bilgileri' },
        { id: 'invoice-integrator-info', title: 'Fatura Entegratör Bilgileri' },
        { id: 'merchant-basic-info', title: 'İşyeri Temel Bilgileri' },
        { id: 'merchant-detail-info', title: 'İşyeri Detay Bilgileri' },
        { id: 'tax-financial-info', title: 'Vergi ve Finans Bilgileri' },
        { id: 'date-info', title: 'Tarih Bilgileri' },
        { id: 'hosting-cancellation-info', title: 'Fesih Bilgileri' },
        { id: 'portfolio-integration-info', title: 'Portföy ve Entegrasyon Bilgileri' },
        { id: 'other-settings-info', title: 'Diğer Ayarlar' },
        { id: 'erp-payment-info', title: 'ERP ve Ödeme Bilgileri' },
        { id: 'address-info', title: 'Adres Bilgileri' },
        { id: 'notes-info', title: 'Notlar' },
    ].filter(s => s.id !== 'invoice-integrator-info' || !!posListWatch?.mobilePos), [posListWatch]);
    const [activeSection, setActiveSection] = useState<string>(sections[0].id);
    const activeSectionRef = useRef(activeSection);

    useEffect(() => {
        activeSectionRef.current = activeSection;
    }, [activeSection]);

    const isManualScrollingRef = useRef(false);

    const scrollToSection = (id: string) => {
        isManualScrollingRef.current = true;

        setActiveSection(id);

        const element = sectionRefs.current[id];
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        setTimeout(() => {
            isManualScrollingRef.current = false;
        }, 600);
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer || hasLoading) return;

        let ticking = false;

        const updateActiveSectionFromScroll = () => {
            if (isManualScrollingRef.current) return;

            const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
            const containerTop = scrollContainer.getBoundingClientRect().top;

            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + clientHeight;

            let bestMatch = { id: '', visibleRatio: 0 };

            for (const section of sections) {
                const element = sectionRefs.current[section.id] as HTMLElement | null;
                if (!element || element.offsetHeight === 0) continue;

                const elTop = element.offsetTop;
                const elBottom = elTop + element.offsetHeight;

                const visibleTop = Math.max(elTop, viewportTop);
                const visibleBottom = Math.min(elBottom, viewportBottom);

                const visibleHeight = Math.max(0, visibleBottom - visibleTop);
                const visibleRatio = visibleHeight / element.offsetHeight;

                if (visibleRatio > bestMatch.visibleRatio) {
                    bestMatch = { id: section.id, visibleRatio };
                }
            }

            const nearBottom = scrollHeight - scrollTop - clientHeight < 5;
            if (nearBottom) {
                const lastSection = sections[sections.length - 1];
                if (activeSectionRef.current !== lastSection.id) {
                    setActiveSection(lastSection.id);
                }
                return;
            }

            if (bestMatch.id && bestMatch.id !== activeSectionRef.current) {
                setActiveSection(bestMatch.id);
            }
        };

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    updateActiveSectionFromScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
        updateActiveSectionFromScroll();

        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [sections, hasLoading]);

    const integratorList = [
        {
            label: "ICE Teknoloji",
            value: "30"
        }
    ] as const;

    const payoutBlockReasonOptions = [
        { label: "Fraud Talebine İstinaden", value: "Fraud Talebine İstinaden" },
        { label: "Harcama İtirazı", value: "Harcama İtirazı" },
    ];

    return (
        <>
            {hasLoading ? (
                <Loading />
            ) : (
                <Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="merchant settings tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Üye İşyeri Bilgileri" {...a11yProps(0)} />
                            <Tab label="Yetkili Kişi Bilgileri" {...a11yProps(1)} disabled={!allData?.merchantId} />
                            <Tab label="Banka Bilgileri" {...a11yProps(2)} disabled={!allData?.merchantId} />
                            <Tab label="Para Birimi Kısıtlama" {...a11yProps(3)} disabled={!allData?.merchantId} />
                            <Tab label="Özel İşlemler" {...a11yProps(4)} disabled={!allData?.merchantId} />
                            <Tab label="Cari Bilgileri" {...a11yProps(5)} disabled={!allData?.merchantId} />
                            <Tab label="Üye İşyeri Banka Yetkilendirme" {...a11yProps(6)} disabled={!allData?.merchantId} />
                        </Tabs>
                    </Box>

                    <CustomTabPanel value={tabValue} index={0}>
                        <Box sx={{ display: 'flex', height: 'calc(100vh - 240px)', bgcolor: 'grey.60' }}>
                            <Paper elevation={0} sx={{ width: 280, minWidth: 280, overflowY: 'auto', borderRight: 1, borderColor: 'divider', marginTop: 2, marginBottom: 2, marginLeft: 1 }}>
                                <List component="nav" sx={{ p: 2 }}>
                                    {sections.map((section) => (
                                        <ListItemButton
                                            key={section.id}
                                            selected={activeSection === section.id}
                                            onClick={() => scrollToSection(section.id)}
                                            sx={{ borderRadius: 1, mb: 1 }}
                                        >
                                            <ListItemText primary={section.title} />
                                        </ListItemButton>
                                    ))}
                                </List>
                            </Paper>

                            <Box ref={scrollContainerRef} sx={{ flex: 1, overflowY: 'auto', p: isDesktop ? 2 : 2, position: 'relative' }}>
                                <Stack spacing={3}>
                                    <Card variant="outlined" id="company-info" ref={el => (sectionRefs.current['company-info'] = el)}>
                                        <CardHeader title="Şirket ve İşyeri Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                <FormControl sx={{ width: isDesktop ? "33.3%" : "100%" }}>
                                                    {merchantTypes && (
                                                        <Controller
                                                            control={control}
                                                            name="merchantType"
                                                            render={({ field: { onChangeT, valueT }, fieldState }) => (
                                                                <Autocomplete
                                                                    onChange={(event, selectedValue) => {
                                                                        setSelectedCompanyType(selectedValue.value);
                                                                        setValue("merchantType", selectedValue?.value || 0);
                                                                    }}
                                                                    id="merchantType"
                                                                    options={merchantTypes}
                                                                    value={selectedCompanyType ? merchantTypes.find((option) => option.value == selectedCompanyType) : {}}
                                                                    getOptionLabel={(option: { label: string; value: number; }) => option.label ?? ""}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="Şirket Tipi" error={fieldState.invalid} />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "33.3%" : "100%" }}>
                                                    {workplaceTypes && (
                                                        <Controller
                                                            control={control}
                                                            name="workplaceType"
                                                            render={(fieldState) => (
                                                                <Autocomplete
                                                                    onChange={(event, selectedValue) => {
                                                                        setSelectedWorkplaceType(selectedValue);
                                                                        setValue("workplaceType", selectedValue?.value || 0);
                                                                    }}
                                                                    id="workplaceType"
                                                                    options={workplaceTypes}
                                                                    value={selectedWorkplaceType ? selectedWorkplaceType : {}}
                                                                    getOptionLabel={(option: { label: string; value: number; }) => option.label ?? ""}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="İşyeri Tipi" error={fieldState.invalid} />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                </FormControl>
                                                <FormControl
                                                    component="fieldset"
                                                    sx={{
                                                        width: isDesktop ? "33.3%" : "100%",
                                                        border: `1px solid ${theme.palette.divider}`,
                                                        borderRadius: theme.shape.borderRadius,
                                                        p: 2,
                                                        pt: 1.5,
                                                        position: 'relative',
                                                    }}
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 12,
                                                            transform: 'translateY(-50%)',
                                                            background: theme.palette.background.paper,
                                                            px: 1,
                                                            fontSize: '0.75rem',
                                                            color: 'text.secondary'
                                                        }}
                                                    >
                                                        POS Tipi
                                                    </FormLabel>
                                                    <FormGroup row>
                                                        {posTypes?.filter(pt => pt.value !== 'mobilePos').map(posType => (
                                                            <Controller
                                                                key={posType.value}
                                                                name={`posList.${posType.value}`}
                                                                control={control}
                                                                render={({ field }) => <FormControlLabel control={<Checkbox {...field} checked={!!field.value} />} label={posType.label} />}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                </FormControl>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="invoice-integrator-info" ref={el => (sectionRefs.current['invoice-integrator-info'] = el)}>
                                        <CardHeader
                                            title="Fatura Entegratör Bilgileri"
                                            sx={{ bgcolor: 'action.hover' }}
                                            action={
                                                <Controller
                                                    name="posList.mobilePos"
                                                    control={control}
                                                    render={({ field }) => {
                                                        const mobilePosItem = posTypes?.find(p => p.value === 'mobilePos');
                                                        return mobilePosItem ? <FormControlLabel control={<Checkbox {...field} checked={!!field.value} />} label={mobilePosItem.label} /> : null;
                                                    }}
                                                />
                                            }
                                        />
                                        {posListWatch?.mobilePos && (
                                            <CardContent>
                                                <Stack spacing={3} direction="column">
                                                    <Stack width={"100%"} spacing={3} direction={isDesktop ? 'row' : 'column'}>
                                                        <ComboboxWithFreeText
                                                            control={control}
                                                            name="integratorGbAlias"
                                                            label="E-Fatura Entegratör Gib değeri"
                                                            options={gbAliasList}
                                                            isDisabled={false}
                                                            isLoading={isGetGbAliasLoading}
                                                            state={isTaxAndInvoiceGbAliasValid ? ComboboxState.DEFAULT : ComboboxState.WARNING}
                                                            stateText={"Vergi Numarası ile Girilen Etiket değeri eşleşmemektedir"}
                                                        />
                                                        <ComboboxWithFreeText
                                                            control={control}
                                                            name="integratorEArchiveGbAlias"
                                                            label="E-Arşiv Entegratör Gib değeri"
                                                            options={gbAliasList}
                                                            isDisabled={false}
                                                            isLoading={isGetGbAliasLoading}
                                                            state={isTaxAndEArchiveGbAliasValid ? ComboboxState.DEFAULT : ComboboxState.WARNING}
                                                            stateText={"Vergi Numarası ile Girilen Etiket değeri eşleşmemektedir"}
                                                        />
                                                    </Stack>
                                                    <Stack width={"100%"} spacing={3} direction={isDesktop ? 'row' : 'column'}>
                                                        <Controller
                                                            name="integratorId"
                                                            control={control}
                                                            defaultValue="30"
                                                            render={({ field: { onChange, value } }) => (
                                                                <Select sx={{ width: isDesktop ? "33%" : "100%" }} value={value} onChange={onChange} disabled={true} label="Fatura Entegratör">
                                                                    {integratorList.map((option) => (
                                                                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                        <InputControl sx={{ width: isDesktop ? "33%" : "100%" }} id="integratorUid" control={control} label="Fatura Entegratör Kullanıcı Adı" />
                                                        <InputControl sx={{ width: isDesktop ? "33%" : "100%" }} id="integratorPwd" control={control} label="Fatura Entegratör Şifresi" />
                                                    </Stack>
                                                </Stack>
                                            </CardContent>
                                        )}
                                    </Card>

                                    <Card variant="outlined" id="merchant-basic-info" ref={el => (sectionRefs.current['merchant-basic-info'] = el)}>
                                        <CardHeader title="İşyeri Temel Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    {merchantList && (
                                                        <Controller
                                                            control={control}
                                                            name="parentMerchantId"
                                                            render={(fieldState) => (
                                                                <Autocomplete
                                                                    onChange={(event, selectedValue) => {
                                                                        setSelectedMerchant(selectedValue);
                                                                        setValue("parentMerchantId", selectedValue?.value || 0);
                                                                    }}
                                                                    id="parentMerchantId"
                                                                    options={merchantList}
                                                                    value={selectedMerchant ? selectedMerchant : {}}
                                                                    getOptionLabel={(option: { label: string; value: number; }) => option.label ?? ""}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="Ana İşyeri" error={fieldState.invalid} />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    {merchantStatuses ? (
                                                        <Controller
                                                            name="merchantStatusType"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field: { onChange, value }, fieldState }) => {
                                                                const selectedMerchantStatus = merchantStatuses.find((option) => option.value === value);
                                                                return (
                                                                    <Autocomplete
                                                                        id="merchantStatusType"
                                                                        options={merchantStatuses}
                                                                        getOptionSelected={(option, value) => option.value === value}
                                                                        getOptionLabel={(option) => option.label}
                                                                        value={selectedMerchantStatus || null}
                                                                        onChange={(_, newValue) => { onChange(newValue ? newValue.value : ""); }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="İşyeri Durumu" error={fieldState.invalid} />
                                                                        )}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    ) : null}
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <InputControl id="merchantName" control={control} label="İşyeri Adı" />
                                                </FormControl>
                                            </Stack>
                                            {selectedMerchantStatus === "BLOCKED" &&
                                                <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} sx={{ marginTop: '24px' }}>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <InputControl id="merchantStatusDescription" control={control} label="Geçici Pasif Nedeni Açıklaması" />
                                                    </FormControl>
                                                </Stack>
                                            }
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="merchant-detail-info" ref={el => (sectionRefs.current['merchant-detail-info'] = el)}>
                                        <CardHeader title="İşyeri Detay Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <InputControl id="tradeName" control={control} label="İşyeri Ticari Adı" />
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <InputControl id="tradeRegistrationNumber" control={control} label="Sicil No" numeric />
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    {commissionProfileList ? (
                                                        <Controller
                                                            name="commissionProfileCode"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field: { onChange, value }, fieldState }) => {
                                                                const selectedCommissionProfile = commissionProfileList.find((option) => option.value === value);
                                                                return (
                                                                    <Autocomplete
                                                                        id="commissionProfileCode"
                                                                        options={commissionProfileList}
                                                                        getOptionSelected={(option, value) => option.value === value}
                                                                        getOptionLabel={(option) => option.label}
                                                                        value={selectedCommissionProfile || null}
                                                                        onChange={(_, newValue) => { onChange(newValue ? newValue.value : ""); }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Çalışma Grubu" error={fieldState.invalid} />
                                                                        )}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    ) : null}
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <InputControl id="employeeCount" control={control} label="Çalışan Sayısı" numeric />
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <InputControl id="estimatedGiro" control={control} label="Tahmini Ciro" numeric />
                                                </FormControl>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="tax-financial-info" ref={el => (sectionRefs.current['tax-financial-info'] = el)}>
                                        <CardHeader title="Vergi ve Finans Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="webSite" control={control} label="Web Sitesi" />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {cityList && (
                                                            <Controller
                                                                control={control}
                                                                name="city"
                                                                render={({ field: { onChange, value }, fieldState }) => (
                                                                    <Autocomplete
                                                                        id="city"
                                                                        options={cityList}
                                                                        value={selectedCity || null}
                                                                        onChange={(event, selectedValue) => {
                                                                            setSelectedCity(selectedValue);
                                                                            onChange(selectedValue);
                                                                        }}
                                                                        getOptionLabel={(option) => option.label}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Vergi Dairesi İli" error={fieldState.invalid} />
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="taxNumber" control={control} label="Vergi Numarası" numeric maxLength={10} />
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {taxAdministrations ? (
                                                            <Controller
                                                                name="taxOfficeCode"
                                                                control={control}
                                                                defaultValue=""
                                                                rules={{ required: true }}
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    const selectedTaxAdministration = taxAdministrations.find((option) => option.value === value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="taxOfficeCode"
                                                                            options={taxAdministrations}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={selectedTaxAdministration || null}
                                                                            onChange={(_, newValue) => { onChange(newValue ? newValue.value : ""); }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Vergi Dairesi" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="citizenshipNumber" control={control} label="Kimlik Numarası" numeric maxLength={11} />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {merchantCategoryList && (
                                                            <Controller
                                                                control={control}
                                                                name="mcc"
                                                                defaultValue=""
                                                                rules={{ required: true }}
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    const selectedMerchantCategory = merchantCategoryList.find((option) => option.value === value);
                                                                    return (
                                                                        <Autocomplete
                                                                            options={merchantCategoryList}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={selectedMerchantCategory || null}
                                                                            onChange={(_, newValue) => { onChange(newValue ? newValue.value : ""); }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="MCC" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {originalMccList && (
                                                            <Controller
                                                                control={control}
                                                                name="originalMcc"
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    const selectedOriginalMcc = originalMccList.find((option) => option.value === value);
                                                                    return (
                                                                        <Autocomplete
                                                                            options={originalMccList}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={selectedOriginalMcc || null}
                                                                            onChange={(_, newValue) => {
                                                                                const newVal = newValue ? newValue.value : "";
                                                                                onChange(newVal);
                                                                                setValue("originalMcc", newVal);
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Original MCC" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="date-info" ref={el => (sectionRefs.current['date-info'] = el)}>
                                        <CardHeader title="Tarih Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <DatePickerControl id="openingDate" control={control} label="İşyeri Açılış Tarihi" defaultValue={dayjs()} />
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <DatePickerControl id="aggreementDate" control={control} label="İşyeri Sözleşme Başlangıç Tarihi" defaultValue={dayjs()} />
                                                </FormControl>
                                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                    <DatePickerControl id="closedDate" control={control} label="İşyeri Sözleşme Bitiş Tarihi " disabled={!isPassiveSelected} defaultValue={dayjs()} />
                                                </FormControl>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="hosting-cancellation-info" ref={el => (sectionRefs.current['hosting-cancellation-info'] = el)}>
                                        <CardHeader title="Fesih Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {annulmentCodes ? (
                                                            <Controller
                                                                name="annulmentCode"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    const selectedAnnulmentCode = annulmentCodes.find((option) => option.value === value);
                                                                    return (
                                                                        <Autocomplete
                                                                            disabled={!isPassiveSelected}
                                                                            id="annulmentCode"
                                                                            options={annulmentCodes}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={selectedAnnulmentCode || null}
                                                                            onChange={(_, newValue) => { onChange(newValue ? newValue.value : ""); }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Fesih Nedeni" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="annulmentStaff" control={control} label="Fesih Personel Adı Soyadı" isDisabled={!isPassiveSelected} />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <ComboboxWithFreeText
                                                            control={control}
                                                            name="passiveReason"
                                                            label="Kapama Nedeni"
                                                            options={merchantPassiveReasons?.map(reason => ({ label: reason.label, value: reason.label })) || []}
                                                            isDisabled={!isPassiveSelected}
                                                            defaultValue=""
                                                        />
                                                    </FormControl>
                                                </Stack>

                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="portfolio-integration-info" ref={el => (sectionRefs.current['portfolio-integration-info'] = el)}>
                                        <CardHeader title="Portföy ve Entegrasyon Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {userPortfolioList ? (
                                                            <Controller
                                                                name="userPortfolioId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    var getSelected = userPortfolioList.find(x => x.value == value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="userPortfolioId"
                                                                            options={userPortfolioList}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={getSelected || null}
                                                                            onChange={(_, newValue) => {
                                                                                setSelectedUserPortfolio(newValue?.value);
                                                                                onChange(newValue ? newValue.value : "");
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Satış Portföy" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {merchantAllList ? (
                                                            <Controller
                                                                name="integratorMerchantId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    var getSelected = merchantAllList.find(x => x.value == value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="integratorMerchantId"
                                                                            options={merchantAllList}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={getSelected || null}
                                                                            onChange={(_, newValue) => {
                                                                                setIntegratorMerchantId(newValue?.value);
                                                                                onChange(newValue ? newValue.value : "");
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Entegratör Firma" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {integrationTypes ? (
                                                            <Controller
                                                                name="integrationTypeId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    var getSelected = integrationTypes.find(x => x.value == value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="integrationTypeId"
                                                                            options={integrationTypes}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={getSelected || null}
                                                                            onChange={(_, newValue) => {
                                                                                setSelectedIntegrationType(newValue?.value);
                                                                                onChange(newValue ? newValue.value : "");
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Entegrasyon Tipi" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {vPosIntegrationStatusList ? (
                                                            <Controller
                                                                name="vPosIntegrationStatus"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    var getSelected = vPosIntegrationStatusList.find(x => x.value == value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="vPosIntegrationStatus"
                                                                            options={vPosIntegrationStatusList}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={getSelected || null}
                                                                            onChange={(_, newValue) => {
                                                                                setSelectedVPosIntegrationStatus(newValue?.value);
                                                                                onChange(newValue ? newValue.value : "");
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="VPos Entegrasyon Durumu" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        {sectors ? (
                                                            <Controller
                                                                name="sectorId"
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field: { onChange, value }, fieldState }) => {
                                                                    var getSelected = sectors.find(x => x.value == value);
                                                                    return (
                                                                        <Autocomplete
                                                                            id="sectorId"
                                                                            options={sectors}
                                                                            getOptionSelected={(option, value) => option.value === value}
                                                                            getOptionLabel={(option) => option.label}
                                                                            value={getSelected || null}
                                                                            onChange={(_, newValue) => {
                                                                                setSelectedIntegrationType(newValue?.value);
                                                                                onChange(newValue ? newValue.value : "");
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} label="Sektör" error={fieldState.invalid} />
                                                                            )}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        ) : null}
                                                    </FormControl>
                                                    <Box sx={{ width: isDesktop ? "100%" : "100%" }} />
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="other-settings-info" ref={el => (sectionRefs.current['other-settings-info'] = el)}>
                                        <CardHeader title="Diğer Ayarlar" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }} >
                                                        <InputControl id="paymentDescriptionPlaceholder" control={control} label="Müşterinin görüntüleyici ödeme açıklaması" isDisabled={!isPaymentDescriptionActiveState} />
                                                        {errors?.paymentDescriptionPlaceholder && <span>{errors?.paymentDescriptionPlaceholder?.message}</span>}
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%", alignSelf: 'center', alignItems: 'center' }}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={<Checkbox checked={isPaymentDescriptionActiveState} onChange={(e) => setIsPaymentDescriptionActiveState(e.target.checked)} />}
                                                                label="Ödeme ekranında açıklama yazılmasını ister misin?"
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Controller
                                                                    name="isInvoiceSendAsEmailEnabled"
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field: { value, onChange } }) => (
                                                                        <Checkbox checked={value} onChange={(e) => { onChange(e.target.checked); }} />
                                                                    )}
                                                                />
                                                            }
                                                            label="Ekstre Gönderimi Aktif mi?"
                                                        />
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "32.5%" : "100%" }}>
                                                        <Controller
                                                            name="invoiceEmail"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField
                                                                    {...field}
                                                                    label="Ekstre Email (birden fazla mail eklemek isterseniz virgül ile ayırın)"
                                                                    type="text"
                                                                    disabled={!watch('isInvoiceSendAsEmailEnabled')}
                                                                    error={!!fieldState.error}
                                                                    helperText={fieldState.error?.message}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%", alignSelf: 'center' }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Controller
                                                                    name="isCallbackUrlControl"
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field: { value, onChange } }) => (
                                                                        <Checkbox
                                                                            checked={!!value}
                                                                            onChange={(e) => {
                                                                                onChange(e.target.checked);
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            }
                                                            label="Callback URL Kontrolü"
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="callbackUrl" control={control} label="Callback URL" isDisabled={!isCallbackUrlControlWatch} />
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                    <Card variant="outlined" id="erp-payment-info" ref={el => (sectionRefs.current['erp-payment-info'] = el)}>
                                        <CardHeader title="ERP ve Ödeme Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <Controller
                                                            name="erpCustomerCode"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="ERP Müşteri Kodu" type="number" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <Controller
                                                            name="walletNo"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="Cüzdan Numarası" type="number" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <Controller
                                                            name="eftDescription"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="EFT Ödeme Açıklaması" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="paymentBlockedDay" control={control} label="Ödeme Bloke Günü" type="number" numeric />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                                        <InputControl id="blockedDay" control={control} label="Bloke Günü" type="number" numeric />
                                                    </FormControl>
                                                </Stack>
                                                <Stack spacing={3} direction={isDesktop ? "row" : "column"}>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100%", alignSelf: 'center' }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Controller
                                                                    name="isPayoutBlocked"
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field: { value, onChange } }) => (
                                                                        <Checkbox
                                                                            checked={!!value}
                                                                            onChange={(e) => {
                                                                                onChange(e.target.checked);
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            }
                                                            label="Ödeme Blokesi"
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? "50%" : "100" }}>
                                                        <ComboboxWithFreeText
                                                            control={control}
                                                            name="payoutBlockReason"
                                                            label="Ödeme Engel Nedeni"
                                                            options={payoutBlockReasonOptions}
                                                            isDisabled={!isPayoutBlockedWatch}
                                                        />
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="address-info" ref={el => (sectionRefs.current['address-info'] = el)}>
                                        <CardHeader title="Adres Bilgileri" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <Stack direction={isDesktop ? "row" : "column"} spacing={3}>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="addressLine1"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField
                                                                    {...field}
                                                                    label="Adres Satırı 1"
                                                                    error={!!fieldState.error}
                                                                    helperText={fieldState.error?.message}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="addressLine2"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField
                                                                    {...field}
                                                                    label="Adres Satırı 2"
                                                                    error={!!fieldState.error}
                                                                    helperText={fieldState.error?.message}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>

                                                <Stack direction={isDesktop ? "row" : "column"} spacing={3}>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="cityId"
                                                            control={control}
                                                            render={({ field, fieldState }) => (
                                                                <Autocomplete
                                                                    {...field}
                                                                    options={cityList || []}
                                                                    getOptionLabel={(option) => option.label || ''}
                                                                    value={cityList?.find(c => Number(c.value) === Number(field.value)) || null}
                                                                    onChange={(_, newValue) => {
                                                                        field.onChange(newValue?.value || '');
                                                                        setValue('districtId', '');
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="İl" error={fieldState.invalid} />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>

                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="districtId"
                                                            control={control}
                                                            render={({ field, fieldState }) => (
                                                                <Autocomplete
                                                                    {...field}
                                                                    options={districts || []}
                                                                    getOptionLabel={(option) => option.label || ''}
                                                                    value={districts?.find(d => Number(d.value) === Number(field.value)) || null}
                                                                    onChange={(_, newValue) => field.onChange(newValue?.value || '')}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="İlçe" error={fieldState.invalid} />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>

                                                <Stack direction={isDesktop ? "row" : "column"} spacing={3}>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="zipCode"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="Posta Kodu" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="addressPhoneNumber"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="Adres Telefon Numarası" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>

                                                <Stack direction={isDesktop ? "row" : "column"} spacing={3}>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="mobilePhoneNumber"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="Cep Telefonu" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="faxNumber"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="Fax Numarası" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>

                                                <Stack direction={isDesktop ? "row" : "column"} spacing={3}>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="emailAddress1"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="E-posta Adresi 1" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
                                                        <Controller
                                                            name="emailAddress2"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field, fieldState }) => (
                                                                <TextField {...field} label="E-posta Adresi 2" error={!!fieldState.error} helperText={fieldState.error?.message} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                    <Card variant="outlined" id="notes-info" ref={el => (sectionRefs.current['notes-info'] = el)}>
                                        <CardHeader title="Notlar" sx={{ bgcolor: 'action.hover' }} />
                                        <CardContent>
                                            <Stack spacing={3}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <Controller
                                                        name="editorDescription"
                                                        control={control}
                                                        defaultValue=""
                                                        render={({ field, fieldState }) => (
                                                            <TextField
                                                                {...field}
                                                                label="Not"
                                                                multiline
                                                                rows={4}
                                                                error={!!fieldState.error}
                                                                helperText={fieldState.error?.message}
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </CardContent>
                                    </Card>

                                </Stack>
                            </Box>
                        </Box>
                        <Stack direction="row" justifyContent="flex-end" sx={{ p: 1, borderTop: 1, borderColor: 'divider' }}>
                            {!!showCreate && (
                                <Button
                                    variant="contained"
                                    text="Kaydet"
                                    onClick={handleSubmit(onSubmit)}
                                />
                            )}
                        </Stack>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <MerchantAddFormPartnerStep merchant={allData} setAllData={setAllData} allData={allData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={2}>
                        <MerchantAddFormBankStep merchant={allData} setAllData={setAllData} allData={allData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={3}>
                        <MerchantAddFormCurrencyStep merchant={allData} setAllData={setAllData} allData={allData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={4}>
                        <MerchantSpecialSettingsTab merchant={merchant} allData={allData} setAllData={setAllData} formState={formState} setFormState={setFormState} control={control} reset={reset} formStateLimit={formStateLimit} setFormStateLimit={setFormStateLimit} getValues={getValues} setValue={setValue} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={5}>
                        <MerchantAccount merchant={allData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={6}>
                        <MerchantBankAuthorizationPage merchantId={merchantId || allData?.merchantId} />
                    </CustomTabPanel>
                </Box >
            )
            }
        </>
    );
};






